import React from 'react';
import WebinarRegistration from '../section/webinarregisterationpage/WebinarRegistration';

export default function WebinarRegistrationPage() {
  return (
    <div className="h-full">
        <WebinarRegistration />
    </div>
  );
}
